import { render, staticRenderFns } from "./ReassignConnectionsAzPersonsDialog.vue?vue&type=template&id=5cf98e26"
import script from "./ReassignConnectionsAzPersonsDialog.vue?vue&type=script&lang=js"
export * from "./ReassignConnectionsAzPersonsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports